module.exports = __webpack_public_path__ + "media/landing_parts/icons/check-d41c53cca325b7e5845a0f7eb0436cec.png";